<template>
  <v-container fluid
               class="pa-0 d-flex flex-column"
               style="height: inherit"
               :style="
      'background-color:' +
      (ContentBackgroundColor ? ContentBackgroundColor : '#fdfdfd')
    ">
    <v-row v-if="hasToolbar"
           no-gutters
           class="flex-grow-0">
      <v-col>
        <slot name="toolbar">
          <v-toolbar dense
                     flat
                     style="border-bottom: 1px solid rgb(232, 232, 232) !important">
            <slot name="toolbar-content" />
          </v-toolbar>
        </slot>
      </v-col>
    </v-row>

    <v-row v-if="hasPrepend"
           no-gutters
           class="flex-grow-0">
      <v-col>
        <slot name="prepend" />
      </v-col>
    </v-row>

    <v-row no-gutters
           style="flex: 1 1 auto;"
           class="overflow-y-overlay">
      <v-col :class="hasFooter ? 'pb-3' : ''">
        <slot>content</slot>
      </v-col>
    </v-row>

    <v-row v-if="hasAppend"
           no-gutters
           class="flex-grow-0">
      <v-col>
        <slot name="append" />
      </v-col>
    </v-row>

    <v-row v-if="hasFooter"
           no-gutters
           class="flex-grow-0">
      <v-col cols="12">
        <slot name="footer">
          <v-card width="100%"
                  class="rounded-0"
                  style="border-top: 1px solid rgb(232, 232, 232) !important"
                  flat>
            <slot name="footer-content" />
          </v-card>
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "SlottedGrowContainer",
  model: {},
  props: {
    ContentBackgroundColor: String,
  },
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {
    hasToolbar() {
      return !!this.$slots["toolbar"] || !!this.$slots["toolbar-content"];
    },
    hasPrepend() {
      return !!this.$slots["prepend"];
    },
    hasAppend() {
      return !!this.$slots["append"];
    },
    hasFooter() {
      return !!this.$slots["footer"] || !!this.$slots["footer-content"];
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
</style>